module.exports = __webpack_public_path__ + "img/qr_truck.0b7b9a25.jpg";